/*
 *  TTTech nerve-management-system
 *  Copyright(c) 2022. TTTech Industrial Automation AG.
 *
 *  ALL RIGHTS RESERVED.
 *
 *  Usage of this software, including source code, netlists, documentation,
 *  is subject to restrictions and conditions of the applicable license
 *  agreement with TTTech Industrial Automation AG or its affiliates.
 *
 *  All trademarks used are the property of their respective owners.
 *
 *  TTTech Industrial Automation AG and its affiliates do not assume any liability
 *  arising out of the application or use of any product described or shown
 *  herein. TTTech Industrial Automation AG and its affiliates reserve the right to
 *  make changes, at any time, in order to improve reliability, function or
 *  design.
 *
 *  Contact Information:
 *  support@tttech-industrial.com
 *
 *  TTTech Industrial Automation AG, Schoenbrunnerstrasse 7, 1040 Vienna, Austria
 *
 */

import BaseApiService from './base.api-service';

const ENDPOINTS = {
  CAMPAIGN_INFORMATION: '/bom/deployment/get',
  LIST: '/bom/deployment/list',
  DELETE: '/bom/deployment/delete',
  DEPLOY_WORKLOAD: '/bom/nerve/workload/deploy',
  NODE_UPDATE: '/bom/nerve/node/update',

  CAMPAIGN_CONTENT: '/bom/content/get',
  CAMPAIGN_TASK_LIST: '/bom/task/all-tasks-in-campaign',

  MARK_TASK_AS_FINISH: '/bom/task/mark-as-finish',
  MARK_TASK_AS_FAIL: '/bom/task/mark-as-fail',
  MARK_TASK_AS_SUCCESS: '/bom/task/mark-as-success',
};

class CampaignAndTasksApiService extends BaseApiService {
  /** API related to campaigns */
  getCampaignInformation(id) {
    return this.get(`${ENDPOINTS.CAMPAIGN_INFORMATION}/${id}`, { authRequired: true });
  }

  fetchCampaigns(params) {
    return this.get(ENDPOINTS.LIST, params, {
      authRequired: true,
    });
  }

  deleteCampaign(id) {
    return this.delete(`${ENDPOINTS.DELETE}/${id}`, { authRequired: true });
  }

  deployWorkload(param) {
    return this.post(ENDPOINTS.DEPLOY_WORKLOAD, param, { authRequired: true });
  }

  triggerNodeUpdate(selectedDevices, nodeUpdateDetails) {
    return this.post(
      ENDPOINTS.NODE_UPDATE,
      { devices: selectedDevices, version: nodeUpdateDetails },

      { authRequired: true },
    );
  }

  /** API related to content of campaign */
  getCampaignContent(id) {
    return this.get(`${ENDPOINTS.CAMPAIGN_CONTENT}/${id}`, { authRequired: true });
  }

  /** API to fetch all tasks from specific campaign */
  getCampaignTasks(params, logId) {
    return this.get(`${ENDPOINTS.CAMPAIGN_TASK_LIST}/${logId}`, params, {
      authRequired: true,
    });
  }

  /** API related to tasks */
  markTaskAsFinish(id) {
    return this.patch(`${ENDPOINTS.MARK_TASK_AS_FINISH}/${id}`, {}, { authRequired: true });
  }

  markTaskAsFail(id) {
    return this.patch(`${ENDPOINTS.MARK_TASK_AS_FAIL}/${id}`, {}, { authRequired: true });
  }

  markTaskAsSuccess(id) {
    return this.patch(`${ENDPOINTS.MARK_TASK_AS_SUCCESS}/${id}`, {}, { authRequired: true });
  }
}

export default new CampaignAndTasksApiService();
